<mat-card>
  <h2 translate>queries.title</h2>
  <mat-card-content>
    <form [formGroup]="revolvingQueriesForm" (ngSubmit)="consult()">
      <mat-grid-list cols="18" rowHeight="65px">
        <mat-grid-tile *ngIf="isMacroChains || isBussinesDirector" colspan="7">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroChain"
            [id]="'macroChainSelect'"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [isRequired]="true"
            [hasSelectOptionEmpty]="true"
            [showErrors]="revolvingQueriesForm?.controls?.macroChain?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="isMacroOffices || isBussinesDirector" colspan="7">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroOffice"
            [id]="'macroOfficeSelect'"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [isRequired]="true"
            [hasSelectOptionEmpty]="true"
            [showErrors]="revolvingQueriesForm?.controls?.macroOffice?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="14">
          <mat-label fxFlex class="label_request" translate>queries.text</mat-label>
        </mat-grid-tile>

        <mat-grid-tile colspan="7">
          <scf-custom-select-search
            fxFlex="100"
            (selectionChange)="selectRequest($event)"
            formControlName="queryType"
            [id]="'queryTypeQueriesRevolving'"
            [dataInput]="queryTypes"
            [placeholder]="'queries.queryType'"
            [hasToTranslateValue]="true"
            [showErrors]="revolvingQueriesForm?.controls?.queryType?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="7" *ngIf="showSelectOption">
          <scf-custom-select-search
            [id]="'selectOptionQueriesRevolving'"
            formControlName="selectOption"
            fxFlex="100"
            [dataInput]="optionsList"
            [placeholder]="'queries.selectOption'"
            [showErrors]="revolvingQueriesForm?.controls?.selectOption?.errors"
          >
          </scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="8" *ngIf="!showSelectOption"></mat-grid-tile>

        <mat-grid-tile colspan="7" *ngIf="showDetail">
          <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-between start" class="radio-buttons_box">
            <label><strong translate>queries.detailFor</strong></label>
            <mat-radio-group formControlName="radioButtonDetail">
              <mat-radio-button *ngIf="showGroupOption" (change)="selectOptionRadioButton()" value="C">{{
                'queries.group' | translate
              }}</mat-radio-button>
              <mat-radio-button (change)="selectOptionRadioButton()" value="P">{{
                'queries.prescriber' | translate
              }}</mat-radio-button>
              <mat-radio-button (change)="selectOptionRadioButton()" value="E">{{
                'queries.establishment' | translate
              }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="14">
          <label fxFlex class="label_request"><strong translate>queries.requestToConsult</strong></label>
        </mat-grid-tile>

        <mat-grid-tile colspan="5">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="liquidations"
            [id]="'liquidationsQueriesRevolving'"
            [dataInput]="liquidationsList"
            [placeholder]="'queries.selectLiquidations'"
            [hasToTranslateValue]="true"
            [showErrors]="revolvingQueriesForm?.controls?.liquidations?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="5">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>queries.from</mat-label>
            <input
              id="fromDateQueriesRevolving"
              matInput
              formControlName="initialDate"
              [matDatepicker]="datepickerFrom"
              [max]="currentDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #datepickerFrom></mat-datepicker>
            <mat-error *ngIf="revolvingQueriesForm.controls.initialDate.hasError('matDatepickerParse')" translate>
              queries.error.format
            </mat-error>
            <mat-error *ngIf="revolvingQueriesForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="5">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>queries.until</mat-label>
            <input
              id="toDateQueriesRevolving"
              matInput
              formControlName="finalDate"
              [matDatepicker]="datepickerUntil"
              [min]="minFinalDate"
              [max]="currentDate"
              (dateChange)="checkDate()"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerUntil"></mat-datepicker-toggle>
            <mat-datepicker #datepickerUntil></mat-datepicker>
            <mat-error
              *ngIf="
                revolvingQueriesForm.controls.finalDate.hasError('matDatepickerMin') ||
                revolvingQueriesForm.controls.finalDate.hasError('lowerDate')
              "
              translate
            >
              queries.error.dateOrder
            </mat-error>
            <mat-error *ngIf="revolvingQueriesForm.controls.finalDate.hasError('matDatepickerParse')" translate>
              queries.error.format
            </mat-error>
            <mat-error *ngIf="revolvingQueriesForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <div fxFlex="100" appearance="outline" fxLayout="row" fxLayoutAlign="center center" class="details_button">
            <button
              id="seeDetailsButtonHome"
              color="accent"
              mat-flat-button
              type="submit"
              [disabled]="revolvingQueriesForm.invalid || disableSearch || !isSelectedOption"
            >
              <mat-label translate>queries.seeDetail</mat-label>
            </button>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="hasAnyOperation()">
  <!-- HEADER -->
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2 translate>queries.results</h2>
    <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
      <button id="createExcelPanel" mat-stroked-button color="accent" (click)="createExcel()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'request.button.excel' | translate | uppercase }}</span>
      </button>
      <button id="createPdfPanel" mat-stroked-button color="accent" (click)="createPdf()">
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'request.button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <!-- CONTENT -->
  <mat-card-content>
    <div class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="queries" mat-table [dataSource]="dataSource" *ngIf="hasAnyOperation()">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.date</th>
          <td mat-cell *matCellDef="let element">{{ element.strFecha }}</td>
        </ng-container>
        <ng-container matColumnDef="contract">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.contract</th>
          <td mat-cell *matCellDef="let element">{{ element.strNumCon }}</td>
        </ng-container>
        <ng-container matColumnDef="nifnie">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.nifnie</th>
          <td mat-cell *matCellDef="let element">{{ element.strDniCif }}</td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.customerName</th>
          <td mat-cell *matCellDef="let element">{{ element.strNombre }}</td>
        </ng-container>
        <ng-container matColumnDef="import">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.import</th>
          <td
            mat-cell
            *matCellDef="let element"
            [ngClass]="element.dblImModLoc >= 0 ? '--text-color-green' : '--text-color-red'"
          >
            {{ element.dblImModLoc | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.type</th>
          <td mat-cell *matCellDef="let element">{{ element.strTipOper }}</td>
        </ng-container>
        <ng-container matColumnDef="term">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.term</th>
          <td mat-cell *matCellDef="let element">{{ element.strNuCuotas }}</td>
        </ng-container>
        <ng-container matColumnDef="expenses">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.expenses</th>
          <td mat-cell *matCellDef="let element">{{ element.dblGastos | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="netAmount">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.netAmount</th>
          <td mat-cell *matCellDef="let element">{{ element.dblImpNeto | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="liquidationDate">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.liquidationDate</th>
          <td mat-cell *matCellDef="let element">{{ element.strFechaLiq }}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef translate>queries.header.description</th>
          <td mat-cell *matCellDef="let element">{{ element.strDescripcion }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="mat-cell--buttons">
            <button
              id="printButtonQueryRevolving"
              mat-stroked-button
              class="mat-cell__buttons"
              (click)="onClickPrintQuery(element)"
            >
              <mat-icon class="icon-ic_print"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div class="queries__paginator">
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="queries__paginator-buttons"
        (click)="onClickPreviousPage()"
        *ngIf="isPreviousButtonDisplayed()"
      >
        <mat-icon class="icon-ic_chevron_left"></mat-icon>
      </button>
      <button
        id="nextPageRequestPanel"
        mat-flat-button
        class="queries__paginator-buttons"
        (click)="onClickNextPage()"
        *ngIf="isNextButtonDisplayed()"
      >
        <mat-icon class="icon-ic_chevron_right"></mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
